import { useMedia } from 'react-use';
import { breakpoints } from '../styles/theme';

export const useIsPortraitTablet = () =>
  useMedia(`(max-width: ${parseInt(breakpoints.sm)}px)`);
